exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".apptemplate-delete .modal-dialog{width:350px}@media (max-width:768px){.apptemplate-delete .modal-dialog{top:30%}}.btn-mouseover:hover{background:#55dcb7;border-color:#55dcb7}a.button:hover,a.fancybox-modal.send:hover,a.form-link:hover,a.remove.fancybox-modal2:hover{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./directives/quickformsTable/removeModal.css
// module id = 460
// module chunks = 0